import { section } from "./global-interfaces";

export const SECTION = "section";
export const CATEGORY = "category";
export const CARD = "card";

// chart types
export const SUBSET = "subset";
export const VERT = "vertical";
export const HORIZ = "horizontal";
export const PIE = "pie";
export const TEXT = "text";
export const NESTED_TEXT = "text_nested";
export const LIST = "list";
export const WORD = "word";
export const SUBHEADER = "subheader";
export const ANNOTATION = "annotation";

// colors
export const ORANGE = "orange";
export const YELLOW = "yellow";
export const GREEN = "green";
export const TEAL = "teal";
export const BLUE = "blue";
export const PINK = "pink";
export const PURPLE = "purple";
export const SECONDARY = "secondary";
export const TERTIARY = "tertiary";

// sections
export const INTRODUCTION = "Introduction";
export const SUICIDALITY = "Suicidality & Mental Health";
export const DISCLOSURE = "Disclosure";
export const DISCRIMINATION = "Discrimination & Physical Harm";
export const CONVERSION = "Conversion Therapy & Change Attempts";
export const CRISIS = "Youth Support Preferences";
export const DIVERSITY = "Diversity";
export const METHODOLOGY = "Methodology";

// social
export const LINK = "link";
export const TWITTER = "twitter";
export const FB = "facebook";

//misc.
export const EMPHASIS_CHAR = "^";
export const TITLE_CHAR = "#";
export const FOOTNOTE_CHAR = "_";
export const LIST_CHAR = "+";
export const TITLE = "title";
export const SUBTITLE = "subtitle";
export const HIGHLIGHT = "highlight";

// color mappings
const formatHash = (str: string) => str.replace("&", "").replace(/(\s+)/g, "-"); // replaces '&' and ' ' with '-'
export const SECTION_MAPPING: section[] = [
  {
    title: INTRODUCTION,
    color: ORANGE,
    hash: formatHash(INTRODUCTION),
    path: "/assets/info-outline.svg",
    pathActive: "/assets/info-fill.svg",
  },
  {
    title: SUICIDALITY,
    color: GREEN,
    hash: formatHash(SUICIDALITY),
    path: "/assets/t-icons-suicide-outline.svg",
    pathActive: "/assets/t-icons-suicide-fill.svg",
  },
  {
    title: CONVERSION,
    color: BLUE,
    hash: formatHash(CONVERSION),
    path: "/assets/change1-outline.svg",
    pathActive: "/assets/change1-fill.svg",
  },
  {
    title: DISCRIMINATION,
    color: TEAL,
    hash: formatHash(DISCRIMINATION),
    path: "/assets/trevor-danger-outline.svg",
    pathActive: "/assets/trevor-danger-fill.svg",
  },
  {
    title: DISCLOSURE,
    color: YELLOW,
    hash: formatHash(DISCLOSURE),
    path: "/assets/heart-outline.svg",
    pathActive: "/assets/heart-fill.svg",
  },
  {
    title: CRISIS,
    color: PINK,
    hash: formatHash(CRISIS),
    path: "/assets/chat-outline.svg",
    pathActive: "/assets/chat-fill.svg",
  },
  {
    title: DIVERSITY,
    color: ORANGE,
    hash: formatHash(DIVERSITY),
    path: "/assets/research-outline.svg",
    pathActive: "/assets/research-fill.svg",
  },
  {
    title: METHODOLOGY,
    color: PURPLE,
    hash: formatHash(METHODOLOGY),
    path: "/assets/methodology-outline.svg",
    pathActive: "/assets/methodology-fill.svg",
  },
].map((d, i) => ({ ...d, index: i }));
